(function () {
  'use strict';
  if (window.PartifyVehiclePaintPreference) return;
  const clean = value => String(value || '').trim();
  const token = value => clean(value).toLowerCase().replace(/\s+/g, ' ');
  const vin = vehicle => /^[A-HJ-NPR-Z0-9]{17}$/i.test(clean(vehicle?.vin)) ? clean(vehicle.vin).toUpperCase() : '';
  const timestamp = vehicle => Date.parse(vehicle?.selectedPaintCodeUpdatedAt || '') || 0;

  function read() {
    try {
      const vehicles = JSON.parse(localStorage.getItem('searchTerms') || '[]');
      return Array.isArray(vehicles) ? vehicles : [];
    } catch (_) { return []; }
  }

  function active() { return read()[0] || null; }
  function owner() {
    try { return localStorage.getItem('partifyGarageOwner') || ''; } catch (_) { return ''; }
  }

  function key(vehicle = active()) {
    if (vin(vehicle)) return 'vin:' + vin(vehicle);
    if (![vehicle?.year, vehicle?.make, vehicle?.model].every(value => clean(value))) return '';
    return ['ymm', vehicle.year, vehicle.make, vehicle.model].map(token).join('|');
  }

  function code(value) {
    const prefix = clean(value).split(/\s*[—–·+]\s*|\s+-\s+/)[0];
    const match = prefix.match(/^[a-z0-9.-]+(?:\s*[/,|]\s*[a-z0-9.-]+)*/i)?.[0];
    if (!match || /^(unpainted|sin|default|\.vin|vin|unknown|n\/a|match|custom|two(?:-tone)?)$/i.test(match)) return '';
    return match.toUpperCase().replace(/\s*[/,|]\s*/g, '/');
  }

  function selected(vehicle = active()) { return code(vehicle?.selectedPaintCode); }
  function preferred(vehicle = active()) { return selected(vehicle) || clean(vehicle?.paintCode); }

  function matches(finish, preference) {
    const aliases = value => code(value).split('/').filter(Boolean).map(value => value.replace(/^WA(?=[A-Z0-9])/, ''));
    return aliases(finish).some(value => aliases(preference).includes(value));
  }

  function merge(local, remote) {
    if (!selected(local) || (selected(remote) && timestamp(remote) >= timestamp(local))) return remote;
    return { ...remote, selectedPaintCode: selected(local), selectedPaintCodeUpdatedAt: clean(local.selectedPaintCodeUpdatedAt) };
  }

  function capture(value) {
    const vehicle = active();
    return { vehicle, paintCode: code(value), owner: owner() };
  }

  function captureVariant(variantId) {
    const option = Array.from(document.getElementById('variant-selector')?.options || []).find(option => String(option.value) === String(variantId));
    const variant = Object.values(window.productVariants || {}).filter(Array.isArray).flat().find(variant => String(variant.id) === String(variantId));
    return capture(option?.dataset.variantTitle || variant?.variantTitle || '');
  }

  function remember(value, vehicle = active(), expectedUpdatedAt) {
    const paintCode = code(value);
    if (!paintCode || !key(vehicle)) return false;
    const vehicles = read();
    let index = vehicles.findIndex(entry => key(entry) === key(vehicle));
    if (index < 0 && !vin(vehicle)) {
      const candidates = vehicles.map((entry, index) => ({ entry, index })).filter(({ entry }) =>
        ['year', 'make', 'model'].every(field => token(entry?.[field]) === token(vehicle[field])));
      if (candidates.length === 1) index = candidates[0].index;
    }
    if (index < 0) return false;
    const current = vehicles[index];
    if (expectedUpdatedAt !== undefined && timestamp(current) > (Date.parse(expectedUpdatedAt || '') || 0) && selected(current) !== paintCode) return false;
    if (selected(current) === paintCode && current.selectedPaintCodeUpdatedAt) return true;
    vehicles[index] = { ...current, selectedPaintCode: paintCode, selectedPaintCodeUpdatedAt: new Date(Math.max(Date.now(), timestamp(current) + 1)).toISOString() };
    try { localStorage.setItem('searchTerms', JSON.stringify(vehicles)); } catch (_) { return false; }
    window.dispatchEvent(new CustomEvent('partify:paint-preference:changed', { detail: { vehicleKey: key(vehicles[index]) } }));
    window.dispatchEvent(new Event('garageUpdated'));
    return true;
  }

  function confirm(context) {
    if (!context || context.owner !== owner()) return false;
    return remember(context.paintCode, context.vehicle, context.vehicle?.selectedPaintCodeUpdatedAt || '');
  }

  window.PartifyVehiclePaintPreference = { active, key, code, selected, preferred, matches, merge, capture, captureVariant, remember, confirm };
})();
